module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "signInForm",
    staticClass: "sign-in-form",
    attrs: {
      "id": "sign-in-form-id",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', {
    staticClass: "text-center mb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "Logo"
    }
  })])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin": "0px 20px 0px 0px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                      Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                      GST Registration no. 201608755R"), _c('br'), _vm._v("\n                      51 Goldhill Plaza"), _c('br'), _vm._v("\n                      #14-01"), _c('br'), _vm._v("\n                      Singapore 308900"), _c('br'), _vm._v("\n                      finance@getkobe.com\n                    ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("\n                      Content Creator Details\n                    ")]), _vm._v(" "), (_vm.displayData.platform === 'tiktok') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      TikTok Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'instagram') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Instagram Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'youtube') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Youtube Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'twitter') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      X (Twitter) Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'others') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("platformDisplayName")(_vm.displayData.platformName)) + " Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Platform Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Company Rep Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v("Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('br'), _vm._v("\n                      (+65) 6255 5662 "), _c('br'), _vm._v("\n                      finance@getkobe.com\n                    ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.displayData.campaignName))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("\n                      Campaign Ref: " + _vm._s(_vm.displayData.campaignID) + "\n                    ")])])])], 1), _vm._v(" "), (_vm.pairingDetails.deliverables_details) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "1px solid black"
    }
  }, [_c('thead', {
    staticClass: "brand-secondary-bg"
  }, [_c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("AMOUNT")])])]), _vm._v(" "), _c('tbody', [(_vm.pairingDetails.deliverables_details.no_of_stories) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Story")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_stories))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_stories')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_xhs_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("XHS Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_xhs_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_xhs_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_tiktok_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("TikTok Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_tiktok_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_tiktok_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_carousels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_carousels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_carousels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_video) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Video")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_video))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_video')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_igTv) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG TV")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_igTv))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_igTv')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_reels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Reels")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_reels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_reels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_li_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_li_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_li_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_x_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_x_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_x_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.youtube) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Youtube")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.youtube))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('youtube')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.loading_whitelisting) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Loading/Whitelisting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.loading_whitelisting))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('loading_whitelisting')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.exclusivity) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Exclusivity ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.exclusivity))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('exclusivity')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.physical_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Physical Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.physical_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('physical_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.online_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Online Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.online_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('online_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_fb_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Facebook ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_fb_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_fb_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pairingDetails.deliverables_details.custom), function(custom, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', [_vm._v(_vm._s(custom.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(custom.value))]), _vm._v(" "), (index === 0 && _vm.checkShowAmountRowSpan('custom')) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowspan": _vm.getRowSpanCount
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.pairingDetails.payout_details.boostingFees), function(boostingFee, index) {
    return (_vm.pairingDetails.payout_details) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(boostingFee.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(boostingFee.value)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pairingDetails.payout_details.GSTpercent) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("\n                            GST\n                          ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.pairingDetails.payout_details.GSTpercent)))])]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.pairing_details.deliverable_notes) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.pairingDetails.pairing_details.deliverable_notes))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "brand-secondary-total-cell",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(" TOTAL: " + _vm._s(_vm.formatPayout(_vm.pairingDetails.payout_details.amount)) + " ")])])])], 2)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.remarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.pairingDetails.remarks)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.pairing_details && _vm.pairingDetails.pairing_details.remarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.pairingDetails.pairing_details.remarks))
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h2', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("I have read and accepted the terms of use ("), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.getkobe.com/influencer-terms-use-agreement/")]), _vm._v(").")]), _vm._v(" "), _c('li', [_vm._v("I have read and understood supporting campaign details that accompany this brief.")]), _vm._v(" "), _c('li', [_vm._v("I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.")]), _vm._v(" "), _c('li', [_vm._v("Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,\n                        I may forfeit my rate or be deducted a penalty by the client.")]), _vm._v(" "), _c('li', [_vm._v("I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.")]), _vm._v(" "), _c('li', [_vm._v("I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.")]), _vm._v(" "), _c('li', [_vm._v("I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.")]), _vm._v(" "), _c('li', [_vm._v("If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.")]), _vm._v(" "), _c('li', [_vm._v("The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.")])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.pairingDetails.pairing_details) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Please confirm your submission date!")]), _vm._v("\n                    " + _vm._s(_vm.formatSubmissionDate(_vm.pairingDetails.pairing_details.submission_date)) + "\n                    "), _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUpdateSubmissionDialog(_vm.pairingDetails)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "420px"
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 mb-2",
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.clearSignature
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #cfcece",
      "margin-bottom": "10px",
      "max-width": "100%",
      "overflow": "hidden"
    }
  }, [_c('canvas', {
    staticClass: "cls-signature-pad",
    attrs: {
      "id": "signin-signature-pad",
      "width": "400",
      "height": "200"
    }
  })])], 1), _vm._v(" "), (_vm.errors.signature) ? _c('p', {
    staticClass: "text-danger",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Signature field is required.")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Signature")]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Date: " + _vm._s(_vm.todayDate()))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                    Submit\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('update-submission-date-modal', {
    attrs: {
      "value": _vm.updateSubmissionDateDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.refreshPairing,
      "closeModal": _vm.closeSubmissionDialog
    },
    model: {
      value: (_vm.updateSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateSubmissionDateDialog = $$v
      },
      expression: "updateSubmissionDateDialog"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcfc63ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/SigningForm/Form.vue
// module id = 2302
// module chunks = 0